import { tViews } from "../../../../utils/table";

export const siteSummary = {
  data: [
    {
      property: "current",
      format: "percent",
      color: "#00A0D1"
    },
    {
      property: "change",
      format: "changePercent",
      theme: "changeQuality"
    }
  ],
  stats: [
    {
      key: "site_availability",
      get title() { return tViews('summaryTitleSites'); },
      get subTitle() { return tViews('summarysubTitleAvailability'); },
      get tooltip() { return tViews('summaryTooltipAvail'); },
      tooltipKey: "overviewSummaryTooltip",
      get subTitleToolTip() { return tViews('summarySubTitleTooltipAvail'); }
    },
    {
      key: "application_vqoe_health",
      get title() { return tViews('summaryTitleApplications'); },
      get subTitle() { return tViews('summarysubTitleQoe'); },
      get tooltip() { return tViews('summaryTooltipQoe'); },
      tooltipKey: "overviewSummaryTooltipApplicationsQoe",
      get subTitleToolTip() { return tViews('summarysubTitleToolTipQoe'); }
    },
    {
      key: "circuit_availability",
      get title() { return tViews('summaryTitleCircuits'); },
      get subTitle() { return tViews('summarysubTitleAvailability'); },
      get tooltip() { return tViews('summaryTooltipAvail'); },
      tooltipKey: "overviewSummaryTooltipCircuitsAvail",
      get subTitleToolTip() { return tViews('summarysubTitleToolTipAvailability'); }
    }
  ]
};

export const singleSiteSummary = {
  data: [
    {
      property: "current",
      format: "percent",
      color: "#00A0D1"
    },
    {
      property: "change",
      format: "changePercent",
      theme: "changeQuality"
    }
  ],
  siteSummary: {
    key: "summary",
    get title() { return tViews('applicationOverviewLabelSummaryCap'); },
    stats: [
      {
        key: "avg_availability",
        get title() { return tViews('dashletSiteViewAvailabilityWith'); },
        get subTitle() { return tViews('singleSiteSummarySubtitle'); },
        get tooltip() { return tViews('singleSiteSummaryTooltip'); },
        tooltipKey: "avgAvailabilitySummary",
        get subTitleToolTip() { return tViews('singleSiteAvailabilitySummarySubtitleTooltip'); }
      },
      {
        key: "usage",
        get title() { return tViews('dashletSiteViewSitesWith'); },
        get subTitle() { return tViews('deviceUsage'); },
        get tooltip() { return tViews('deviceUsageTooltip'); },
        tooltipKey: "usageSummary",
        get subTitleToolTip() { return tViews('singleSiteUsageSummarySubtitleTooltip'); }
      }
    ]
  },
  stats: [
    {
      key: "devices",
      get title() { return tViews('applicationOverviewLabelDevices'); },
      get subTitle() { return tViews('summarysubTitleAvailability'); },
      get tooltip() { return tViews('summaryTooltipAvail'); },
      tooltipKey: "deviceSummary",
      get subTitleToolTip() { return tViews('summaryDeviceSubTitleTooltipAvail'); }
    },
    {
      key: "application_vqoe_health",
      get title() { return tViews('summaryTitleApplications'); },
      get subTitle() { return tViews('summarysubTitleQoe'); },
      get tooltip() { return tViews('summaryTooltipQoe'); },
      tooltipKey: "overviewSummaryTooltipApplicationsQoe",
      get subTitleToolTip() { return tViews('summarysubTitleToolTipQoe'); }
    },
    {
      key: "circuit_availability",
      get title() { return tViews('circuitViewCircuits'); },
      get subTitle() { return tViews('summarysubTitleAvailability'); },
      get tooltip() { return tViews('summaryTooltipAvail'); },
      tooltipKey: "overviewSummaryTooltipCircuitsAvail",
      get subTitleToolTip() { return tViews('summarysubTitleToolTipAvailability'); }
    }
  ]
};
